/**
 * `--calldata-only` support.
 *
 * When the global `--calldata-only` flag is set, state-changing commands build
 * the unsigned EIP-5792-style calldata via the shared `@sherwoodagent/sdk`
 * encoders and print it as JSON instead of signing/sending — so an external
 * signer (MetaMask Agent Wallet, Frame, Privy, …) that can't export a private
 * key can take the final step. Output matches the HTTP API's `/v1/prepare/*`
 * envelope (the SDK `PreparedAction` shape).
 */
import type { PreparedAction } from "@sherwoodagent/sdk";

let _calldataOnly = false;

/** Set by the root preAction hook from the global `--calldata-only` flag. */
export function setCalldataOnly(value: boolean): void {
  _calldataOnly = value;
}

export function isCalldataOnly(): boolean {
  return _calldataOnly;
}

/**
 * Print a PreparedAction as pretty JSON. Each tx is `{ to, data, value, chainId }`
 * with a hex `value` (EIP-5792). `chainId` is per-tx, so multi-chain flows
 * (e.g. approve-agent: registerAgent on the fund chain + attest on Base)
 * are explicit.
 */
export function emitCalldata(action: PreparedAction): void {
  process.stdout.write(JSON.stringify(action, null, 2) + "\n");
}
